import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { HeaderComponent } from './shared/header-section/header/header.component';
import { SidebarComponent } from './shared/sidebar-section/sidebar/sidebar.component';
import { AuthComponent } from './auth-section/auth/auth.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { AppRoutingModule } from './app-routing.module';
import { ProfileComponent } from './profile-section/profile/profile.component';
import { MultiSelectModule } from 'primeng/multiselect';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DashboardComponent } from './dashboard-section/dashboard/dashboard.component';
import { DocregComponent } from './registeration-section/docreg/docreg.component';
import { AppointmentComponent } from './appointment-section/appointment/appointment.component';
import { CalendarModule } from 'primeng/calendar';
import { NgxPaginationModule } from 'ngx-pagination';
import { AppointmentDashbordComponent } from './appointment-section/appointment-dashbord/appointment-dashbord.component';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { CarouselModule } from 'primeng/carousel';
import { GalleriaModule } from 'primeng/galleria';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { AccordionModule } from 'primeng/accordion';
import { ToastModule } from 'primeng/toast';
import { AddClinicComponent } from './profile-section/add-clinic/add-clinic.component';
import { FileUploadModule } from 'primeng/fileupload';
import { LandingPageComponent } from './landing-page/landing-page.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { RefundPolicyComponent } from './refund-policy/refund-policy.component';
import { TermsConditionComponent } from './terms-condition/terms-condition.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { PatloginComponent } from './Patient/login/patlogin/patlogin.component';
import { PatotpComponent } from './Patient/otp/patotp/patotp.component';
import { PatsignupComponent } from './Patient/signup/patsignup/patsignup.component';
import { PatdashboardComponent } from './Patient/dash/patdashboard/patdashboard.component';
import { CommonModule } from '@angular/common';
// import { AlldoctorComponent } from './patient/doctorlist/alldoctor/alldoctor.component';
// import { AllhospitalComponent } from './patient/hospitallist/allhospital/allhospital.component';
// import { LabsComponent } from './patient/lablist/labs/labs.component';
// import { MhistoryComponent } from './patient/medicalhistory/mhistory/mhistory.component';
// import { DokcategoryComponent } from './patient/doctorcategory/dokcategory/dokcategory.component';
// import { AppointmentsComponent } from './patient/patappointments/appointments/appointments.component';
// import { SingledokComponent } from './Patient/single-doc/singledok/singledok.component';
import { PatsidebarComponent } from './shared/patient-sidebar/patsidebar/patsidebar.component';
import { PatheaderComponent } from './shared/patient-header/patheader/patheader.component';
// import { LogoutComponent } from './patient/pat-logout/logout/logout.component';
// import { ReportsComponent } from './patient/medical-reports/reports/reports.component';
import { FindDoctorComponent } from './find-doctor/find-doctor/find-doctor.component';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { ViewDoctorComponent } from './viewDoctor/view-doctor/view-doctor.component';
import { AboutUsComponent } from './about-us/about-us.component';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { DownloadPageComponent } from './download-page/download-page.component';
import { PricingComponent } from './pricing/pricing.component';
import { FooterComponent } from './shared/footer/footer.component';
import { CitiesComponent } from './shared/cities/cities.component';
import { EmergencyComponent } from './profile-section/emergency/emergency.component';
import { RefrenceComponent } from './refrence/refrence.component';
import { MarketingManagerComponent } from './MR/medical-r/marketing-manager/marketing-manager.component';
import { CompanyLoginComponent } from './MR/medical-r/company-login/company-login.component';
import { MedicalRComponent } from './MR/medical-r/medical-r.component';
import { MrAppointmentComponent } from './MR/medical-r/mr-appointment/mr-appointment.component';
import { MrSignupComponent } from './MR/mr-signup/mr-signup.component';
import { MrpricingComponent } from './MR/mrpricing/mrpricing.component';
import { LabReportsComponent } from './lab-reports/lab-reports.component';
import { DragDropModule } from 'primeng';
import { MembersComponent } from './members/members.component';
import { TestComponent } from './test/test.component';
import { TokenScreenComponent } from './shared/token-screen/token-screen.component';
import { MemberRecordComponent } from './members/member-record/member-record.component';
import { HospitalsiconComponent } from './shared/hospitalsicon/hospitalsicon.component';
import { PatientSubscriptionComponent } from './patient-subscription/patient-subscription.component';
import { RazorpayCheckoutComponent } from './Payments/razorpay-checkout/razorpay-checkout.component';
// import { MatFormField } from '@angular/material/form-field/form-field';
// import { MatFormField }
@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    SidebarComponent,
    AuthComponent,
    ProfileComponent,
    DashboardComponent,
    DocregComponent,
    AppointmentComponent,
    AppointmentDashbordComponent,
    AddClinicComponent,
    LandingPageComponent,
    PrivacyPolicyComponent,
    RefundPolicyComponent,
    TermsConditionComponent,
    PatloginComponent,
    PatotpComponent,
    PatsignupComponent,
    PatdashboardComponent,
    // AlldoctorComponent,
    // AllhospitalComponent,
    // LabsComponent,
    // MhistoryComponent,
    // DokcategoryComponent,
    // AppointmentsComponent,
    // SingledokComponent,
    PatsidebarComponent,
    PatheaderComponent,
    // LogoutComponent,
    // ReportsComponent,
    FindDoctorComponent,
    ViewDoctorComponent,
    AboutUsComponent,
    ContactUsComponent,
    DownloadPageComponent,
    PricingComponent,
    FooterComponent,
    CitiesComponent,
    EmergencyComponent,
    RefrenceComponent,
    MarketingManagerComponent,
    CompanyLoginComponent,
    MedicalRComponent,
    MrAppointmentComponent,
    MrSignupComponent,
    MrpricingComponent,
    LabReportsComponent,
    MembersComponent,
    TestComponent,
    TokenScreenComponent,
    MemberRecordComponent,
    HospitalsiconComponent,
    PatientSubscriptionComponent,
    RazorpayCheckoutComponent,
  ],
  imports: [
    AccordionModule,
    ConfirmDialogModule,
    FileUploadModule,
    ToastModule,
    CarouselModule,
    BrowserModule,
    NgxPaginationModule,
    AutoCompleteModule,
    ReactiveFormsModule,
    FormsModule,
    HttpClientModule,
    RouterModule,
    AppRoutingModule,
    MultiSelectModule,
    BrowserAnimationsModule,
    CalendarModule,
    GalleriaModule,
    FontAwesomeModule,
    CommonModule,
    Ng2SearchPipeModule,
    CalendarModule
    // MatFormField
    // AgmCoreModule.forRoot({
    //   apiKey: 'AIzaSyCs8HrgypINHnnEu7-79axA7XA-E6Hx_hc',
    //   libraries:['places']
    // })
  ],
  providers: [ConfirmationService, MessageService],
  bootstrap: [AppComponent],
})
export class AppModule {}
